export const NOMES_PRODUTOS_API = [
  'LMX.AgendaServicos.WebApi',
  'VendaFacilWebApp',
  'ERP.WebApp',
  'LMX.Suprimentos.WebApi',
  'LMX.CRM.WebApi'
];
